import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import withAuth from "../../components/withAuth";
import qs from "querystringify";

// STATE AND STORE
// LIBS
import API from "../../api";
import {
  fioFromObject,
  getFilialNameFromObject,
  getObjectIdFromField
} from "../../lib/helpers/strings";
import {
  getRoleNameFromObject,
  getRoleStyleFromObject
} from "../../lib/helpers/users";

// UI
import { TelPhones } from "@malond/ui-phone";
import { HeaderPage, Table, Pagination, LinkOrText, Button } from "../../ui";

class UsersListPage extends Component {
  state = {
    titleHeader: "Пользователи",
    loading: true,
    users: {
      list: [],
      meta: {
        page: 0,
        pages: 0,
        count: 0,
        perPage: 0,
        fromRecord: 0,
        toRecord: 0
      }
    },
    query: {
      page: 0
    },
    search: false
  };

  async componentDidMount() {
    const { page, number } = qs.parse(window.location.search);
    const searchParams = {};
    // let search = false;

    if (page > 0) {
      searchParams.page = page;
    }
    if (number > 0) {
      // search = true;
      searchParams.number = number;
      // form.number.value = number;
    }

    const { data, meta } = await API.users.getList(searchParams, {
      full: true
    });

    this.setState({
      loading: false,
      users: {
        list: data,
        meta
      },
      // form,
      // search,
      query: {
        page: page || 0
      }
      // buttons: {
      //   filterDisabled: false
      // }
    });
  }

  onChangedPagination = async page => {
    // const { number } = qs.parse(window.location.search);
    const searchParams = { page };
    const queryParams = { page };

    this.setState({
      loading: true
    });

    // if (number > 0) {
    //   queryParams.number = number;
    // }

    this.props.history.push({
      pathname: "/users",
      search: qs.stringify(queryParams, true)
    });

    // this.setState({
    //   buttons: {
    //     filterDisabled: true
    //   }
    // });

    const { data, meta } = await API.users.getList(
      { ...searchParams },
      { full: true }
    );

    this.setState({
      loading: false,
      users: {
        list: data,
        meta
      },
      query: {
        page
      }
      // buttons: {
      //   filterDisabled: false
      // }
    });
  };

  getTableColumns = () => {
    return [
      {
        title: "",
        className: "id",
        render: ({ i }) => this.state.users.meta.fromRecord + i
      },
      {
        title: "ФИО",
        suffix: "пользователя",
        render: ({ item }) => {
          return <Link to={`/users/${item._id}`}>{fioFromObject(item)}</Link>;
        }
      },
      { title: "Имя пользователя", suffix: "логин", field: "username" },
      {
        title: "Телефон",
        text: "right",
        render: ({ item }) => {
          return <TelPhones className="size-small">{item.tel}</TelPhones>;
        }
      },
      {
        title: "Филиал",
        prefix: "Назначенный",
        render: ({ item }) => {
          return (
            <LinkOrText
              toBeforeId="/filials/"
              id={getObjectIdFromField(item.filial_id)}
            >
              {getFilialNameFromObject(item.filial_id)}
            </LinkOrText>
          );
        }
      },
      {
        title: "Роль",
        prefix: "Назначенная",
        render: ({ item }) => {
          return (
            <span
              className={`label size-small label-${getRoleStyleFromObject(
                item.role_id
              )}`}
            >
              {getRoleNameFromObject(item.role_id)}
            </span>
          );
        }
      }
    ];
  };

  render() {
    const { users } = this.state;

    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage title={this.state.titleHeader} count={users.meta.count}>
          <Button type="as" as={Link} to="/users/create" theme="success">
            Создать
          </Button>
        </HeaderPage>

        <Table
          columns={this.getTableColumns()}
          data={users.list}
          loading={this.state.loading}
        />

        <Pagination
          linkPages={"/users"}
          linkPagesQuery={false}
          count={users.meta.count}
          page={users.meta.page}
          pages={users.meta.pages}
          onClick={this.onChangedPagination}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(UsersListPage));
